import siteConfig from "site-config";
import { fetchJSON } from "lib/fetch";
import { useQuery, QueryConfig } from "react-query";
import type { IScope } from "reducers/scope";
import { stringify } from "query-string";
import { getStore } from "store";
import me from "models/me";
import { ICart } from "constants/cart";
import { IOrder } from "records/order";
import { getOrder } from "components/build-order";
import { PRODUCTS_FILTER } from "constants/brand-settings";

export const PRODUCTS = "products";

// TODO: replace with the generic set of parameters for getItems calls
interface IPayload {
    _id: string;
    __fields: string;
    __populate: string;
    __guest: boolean;
    __company?: string;
    __currency_code?: string;
    __active_pricesheet?: string;
    __warehouses?: string[];
}

interface IProps {
    productId: string;
    cart: ICart;
    scope: IScope;
    company?: string;
    options?: QueryConfig<any>;
}

// TODO: replace by redux fetch to remove individual calls
export const useFetchProductById = ({ productId, cart, scope, company, options }: IProps) => {
    const { scope: storeScope } = getStore().getState();
    let currencyCode = undefined;
    const order: IOrder = getOrder(cart);

    const payload: IPayload = {
        _id: productId,
        __fields: "__all",
        __populate: "__variant",
        __guest: scope?.viewAsGuest,
        __company: company,
        __active_pricesheet: me._activePriceTemplate,
    };

    if (scope.brand.isPricingPromotionEnabled(scope)) {
        currencyCode = storeScope?.currencyCode;
        payload.__currency_code = currencyCode;
    }

    const useOrderWarehouseFiltering =
        scope.brand.getPreference("set_warehouse_for_linesheets") &&
        scope.brand.getPreference("filter_products_by") === PRODUCTS_FILTER.BY_WAREHOUSE_IN_WO;
    if (useOrderWarehouseFiltering && order?.selected_warehouse) {
        payload.__warehouses = [order.selected_warehouse];
    }

    const fetchOptions = {
        method: "GET",
        noDomain: true,
        headers: {
            "Content-Type": "application/json",
            Module: "base",
            "X-Requested-With": "XMLHttpRequest",
            "Active-Brand": scope?.brand?._id,
        },
        credentials: "include" as RequestCredentials,
    };
    const url = `${siteConfig.api}/api/v3.0/items?${stringify(payload)}`;

    return useQuery([PRODUCTS, productId, company, currencyCode], () => fetchJSON<any>(url, fetchOptions), options);
};
